<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .cards {
    display: grid;
    gap: utils.in_rem(12px);

    &.is-overlay {
      grid-template-columns: repeat(3, 1fr);
      @media (max-width: 970px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 740px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }

    &:not(.is-overlay) {
      grid-template-columns: repeat(2, 1fr);
      padding-right: utils.in_rem(12px); // keep away from scrollbar
    }
  }
</style>

<script>
  import CompanyInsightsContainer from "../CompanyInsightsContainer.svelte";
  import ShowMoreButton from "../ShowMoreButton.svelte";
  import { companyInsightsStore, isOverlayStore } from "../stores";
  import FundingCard from "./FundingCard.svelte";

  $: showEmptyState =
    !$companyInsightsStore?.fundingRounds ||
    $companyInsightsStore.fundingRounds.length === 0;

  let showingAllItems = false;

  let innerWidth = 0;

  // Shows one row, regardless of screen size
  $: maxItems = innerWidth < 740 ? 1 : innerWidth < 970 ? 2 : 3;

  $: wrappedRounds =
    showingAllItems || !$isOverlayStore
      ? $companyInsightsStore?.fundingRounds
      : $companyInsightsStore?.fundingRounds?.slice(0, maxItems);

  $: latestRound = $companyInsightsStore?.fundingRounds.sort(
    (a, b) => b.date - a.date
  )[0];
</script>

<svelte:window bind:innerWidth />

<CompanyInsightsContainer {showEmptyState}>
  <div class="cards" class:is-overlay={$isOverlayStore}>
    {#each wrappedRounds as funding}
      <FundingCard {funding} isLatest={funding === latestRound} />
    {/each}
  </div>
  {#if $isOverlayStore && $companyInsightsStore?.fundingRounds.length > maxItems}
    <ShowMoreButton bind:showingMore={showingAllItems} />
  {/if}
  <span slot="noCompanyInfo"> No funding information found </span>
</CompanyInsightsContainer>
